var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: { size: "auto", title: "Schedule Tour" },
      model: {
        value: _vm.createInquiryScheduleModal.visible,
        callback: function($$v) {
          _vm.$set(_vm.createInquiryScheduleModal, "visible", $$v)
        },
        expression: "createInquiryScheduleModal.visible"
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _vm.createInquiryScheduleModal.loading
          ? _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("q-spinner-puff", {
                  attrs: { color: "primary", size: "60px" }
                })
              ],
              1
            )
          : _c("div", { staticClass: "row gutter-sm" }, [
              _vm.shouldShowLiveVideoTourCheckbox()
                ? _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "q-field",
                        [
                          _c("q-checkbox", {
                            attrs: { label: "Live Video Tour" },
                            model: {
                              value: _vm.payload.is_video,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "is_video", $$v)
                              },
                              expression: "payload.is_video"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("autocomplete", {
                    attrs: {
                      method: "autocompleteAgent",
                      filters: {
                        is_tours_capable: true,
                        property_id: _vm.get(
                          _vm.createInquiryScheduleModal,
                          "payload.inquiry.property_id"
                        )
                      },
                      placeholder: "Agent..."
                    },
                    on: {
                      change: _vm.matchAnAgentSelected,
                      clear: _vm.matchAnAgentSelected
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _vm.schedulerUnit
                    ? _c("bj-unit-schedule-tour", {
                        attrs: {
                          unit: _vm.schedulerUnit,
                          "is-video": _vm.payload.is_video,
                          "assignee-id": _vm.payload.agent_id,
                          "chosen-assignee-label": _vm.chosenAssigneeLabel
                        },
                        on: { "time-selected": _vm.onScheduleTourTimeSelected }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-auto" },
                [
                  _c("q-btn", {
                    attrs: {
                      outline: "",
                      disable: _vm.disabled || !_vm.payload.tour_at,
                      label: "Schedule Tour"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.createInquirySchedule($event)
                      }
                    }
                  })
                ],
                1
              )
            ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }